import React from 'react';
import { Button, Paper, Typography } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import useRUMView from 'common-datadog/useRUMView';
import Screen from '../Screen';
import useApplication from '../../resources/applications/read';
import { standardizePhone } from '../../utils/phone';
import AutopayBenefits from '../AutopayBenefits';

const InstallmentWaitingForServiceAdvisor = () => {
  useRUMView('installment-waiting-for-service-advisor');
  const { data: application } = useApplication();
  const merchantPhone = standardizePhone(application.attributes.service_contact_info[1]);

  return (
    <Screen
      header={
        `Waiting for ${application.attributes.service_advisor_name} to enter
        transaction information.`
      }
      subheader={
        `Please contact ${application.attributes.service_advisor_name} at 
        ${application.attributes.dealership_name} to schedule an appointment if you 
        haven't already done so.`
      }
    >
      <Typography variant="body2">
        After
        {' '}
        {application.attributes.service_advisor_name}
        {' '}
        confirms repairs are finished you will be able to review everything
        and enter the amount you want to finance.
      </Typography>
      {merchantPhone
        && (
        <Button
          fullWidth
          type="submit"
          startIcon={<PhoneIcon size={18} />}
          href={`tel:${merchantPhone.normalized}`}
        >
          {merchantPhone.formatted}
        </Button>
        )}
      <Paper
        variant="outlined"
        sx={{ padding: 2, borderRadius: '16px', backgroundColor: '#FAFAFA' }}
      >
        <Typography variant="h4" textAlign="left">
          Did you know?
        </Typography>
        <Typography variant="body2" textAlign="left" sx={{ mb: 2 }}>
          DigniFi offers autopay. It&apos;s secure, convenient, and could save you money.
        </Typography>
        <AutopayBenefits />
        <Typography variant="body2" textAlign="left" sx={{ mt: 3 }}>
          <b>Interested in signing up?</b>
          {' '}
          You&apos;ll have an opportunity to enroll in autopay before
          finalizing your loan documents.
        </Typography>
      </Paper>
    </Screen>
  );
};

export default InstallmentWaitingForServiceAdvisor;
